<template>
  <div class="dropdown product-suite">
    <button
      class="launcher-button"
      type="button"
      title="S2N Health Product Suite"
      aria-label="S2N Health Product Suite"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      data-cy="ProductSuiteLauncher"
      data-test="productSuiteButton"
    >
      <span v-for="n in 9" :key="n" class="dot"></span>
    </button>
    <div
      class="dropdown-menu dropdown-menu-start launcher-menu animate slideIn"
    >
      <div class="launcher-heading">S2N Health Product Suite</div>
      <button
        v-for="item in products"
        :key="item.key"
        type="button"
        :class="['product-option', { selected: item.key === product.selected }]"
        :disabled="isDisabled(item)"
        :aria-disabled="isDisabled(item)"
        :data-test="`productOption-${item.key}`"
        @click="choose(item)"
      >
        <img
          :src="item.logo"
          :alt="item.name"
          class="product-logo"
          :style="{ height: item.menuLogoHeight }"
        />
        <span class="product-tagline">{{ item.tagline }}</span>
        <span
          v-if="isDisabled(item)"
          class="product-disabled-note"
          :data-test="`productDisabledNote-${item.key}`"
        >
          {{ item.disabledNote }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { useProductStore } from "@/store/product";
import { PRODUCTS, PRODUCT_LIST } from "@/services/products";

export default {
  name: "ProductSuiteLauncher",
  setup() {
    const product = useProductStore();
    return { product, products: PRODUCT_LIST };
  },
  methods: {
    isDisabled(item) {
      if (item.key === PRODUCTS.MARKETSIGNAL) {
        return !this.product.enableMarketSignal;
      }
      return !this.product.enableRepSignal;
    },
    async choose(item) {
      if (this.isDisabled(item)) {
        return;
      }
      try {
        await this.product.select(item.key);
      } catch (error) {
        console.error(error);
        return;
      }
      this.$router.push({ name: item.homeRoute });
    },
  },
};
</script>

<style scoped>
.launcher-button {
  width: 34px;
  height: 34px;
  border: 1px solid #d8e3ea;
  background: #fff;
  border-radius: 6px;
  display: grid;
  grid-template-columns: repeat(3, 4px);
  grid-template-rows: repeat(3, 4px);
  gap: 3px;
  align-content: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.15s, border-color 0.15s;
}
.launcher-button:hover,
.launcher-button.show {
  background: #f2f9fb;
  border-color: var(--S2NOceanBlue);
}
.launcher-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(0, 128, 163, 0.25);
}
.dot {
  width: 4px;
  height: 4px;
  background: var(--S2NOceanBlue);
  border-radius: 1px;
}

.launcher-menu {
  width: 300px;
  padding: 14px;
  border: 1px solid #e3eaef;
  border-radius: 10px;
  box-shadow: 0 16px 40px rgba(16, 42, 68, 0.18);
}
.launcher-heading {
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #647485;
  font-weight: 700;
  margin-bottom: 10px;
}
.product-option {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  border: 1px solid #e3eaef;
  border-radius: 8px;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.product-option + .product-option {
  margin-top: 10px;
}
.product-option:hover:not(:disabled) {
  background: #e7f4f8;
}
.product-option:disabled {
  cursor: not-allowed;
  background: #f4f6f8;
}
.product-option:disabled .product-logo {
  opacity: 0.5;
}
.product-option.selected {
  border-color: var(--S2NOceanBlue);
  background: #f2f9fb;
}
.product-logo {
  width: auto;
}
.product-tagline {
  font-size: 12px;
  color: #647485;
}
.product-disabled-note {
  align-self: stretch;
  padding-top: 8px;
  border-top: 1px dashed #d3dce3;
  font-size: 11px;
  line-height: 1.4;
  color: #4a5a6a;
}
</style>
